import { useEffect, useState } from 'react';
import { format } from 'date-fns';

import type { AvailabilityDate } from '../types/TourAvailabilityCards';
import { type AvailabilityEvent, CALENDAR_AVAILABILITY_INPUT_FORMAT_STRING } from '../constants/TourCalendar';

const convertAvailabilityEventsToTourAvailabilityCardsProps = (
  availabilityEvents: Array<AvailabilityEvent>,
): Array<AvailabilityDate> => {
  const dateEventsMap = availabilityEvents.reduce(
    (acc, availabilityEvent) => {
      const dateKey = format(availabilityEvent.start, CALENDAR_AVAILABILITY_INPUT_FORMAT_STRING);

      if (!acc[dateKey]) {
        acc[dateKey] = [];
      }

      acc[dateKey].push({
        start: availabilityEvent.start,
        end: availabilityEvent.end,
      });

      return acc;
    },
    {} as Record<string, Array<{ start: Date; end: Date }>>,
  );

  return Object.entries(dateEventsMap).map(([dateString, timeSlots]) => ({
    date: dateString,
    timeSlots: timeSlots.map((slot) => ({
      start: slot.start,
      end: slot.end,
    })),
  }));
};

export default (availabilityEvents: Array<AvailabilityEvent>) => {
  const [availabilityDates, setAvailabilityDates] = useState<Array<AvailabilityDate>>([]);

  useEffect(() => {
    setAvailabilityDates(
      availabilityEvents.length > 0 ? convertAvailabilityEventsToTourAvailabilityCardsProps(availabilityEvents) : [],
    );
  }, [availabilityEvents]);

  return [availabilityDates, setAvailabilityDates] as const;
};
